export const CONNECTION_TYPES = ['sms', 'email'];
export const PASSWORDLESS_METHOD = ['code', 'link'];
